/*
 * Marquee de títulos de producto a velocidad CONSTANTE.
 *
 * El CSS ya hace el desplazamiento en :hover con transform. Acá solo medimos
 * cuánto sobra el título y calculamos la duración = sobrante / SPEED, así todos
 * los títulos scrollean al mismo ritmo (px/segundo) sin importar el largo.
 * La duración se pasa al CSS por la variable --marquee-duration.
 */
(function () {
  "use strict";

  var SPEED = 50; // px por segundo — subí para acelerar todo el marquee, bajá para frenarlo
  // Sin duración mínima: cualquier tope inferior rompe la velocidad constante
  // (los títulos con poco sobrante quedarían más lentos que el resto).
  var MAX = 10; // solo un freno para títulos extremos (>2000px de sobrante); no toca el caso normal

  function setDuration(card) {
    var title = card.querySelector(".product-title");
    if (!title) return;

    var overflow = title.scrollWidth - title.clientWidth;
    if (overflow <= 0) {
      // Título corto: no hace falta scroll, limpiamos por si cambió el ancho.
      title.style.removeProperty("--marquee-distance");
      title.style.removeProperty("--marquee-duration");
      return;
    }

    // Distancia Y duración salen del MISMO número (overflow), por eso la
    // velocidad es exactamente SPEED px/s para todos: overflow / (overflow/SPEED).
    var secs = Math.min(MAX, overflow / SPEED);
    title.style.setProperty("--marquee-distance", overflow + "px");
    title.style.setProperty("--marquee-duration", secs.toFixed(2) + "s");
  }

  // Delegado: medimos al entrar el mouse en cada card. Corre antes del repaint,
  // así la duración ya está lista cuando arranca la transición de :hover.
  // Cubre también cards agregadas dinámicamente (filtros, paginación, quickview)
  // y recalcula solo si cambió el ancho de la card.
  document.addEventListener(
    "mouseover",
    function (e) {
      var card = e.target.closest && e.target.closest(".single-product-wrap");
      if (!card) return;

      var width = card.offsetWidth;
      if (card._marqueeWidth === width) return; // ya medido para este ancho
      card._marqueeWidth = width;
      setDuration(card);
    },
    { passive: true },
  );

  // Al redimensionar cambia el ancho de las cards → invalidamos el cache.
  window.addEventListener("resize", function () {
    document.querySelectorAll(".single-product-wrap").forEach(function (card) {
      card._marqueeWidth = null;
    });
  });
})();
